import { RoutePathArguments } from "./route-path";


export interface Request<T extends RoutePathArguments = RoutePathArguments>
{
    /** Initial request path. */
    path: string;
    /** Initial request path segments. */
    segments: string[];
    /** The remaining path to be matched with the evaluated routing options. */
    requestPath: string;
    /** The remaining path segments to be matched with the evaluated routing options. */
    requestSegments: string[];
    /** The path portion that was already matched during previous routing evaluations. */
    basePath?: string;
    /** The path segments that were already matched during previous routing evaluations. */
    baseSegments?: string[];
    /** Request extracted arguments. */
    args?: T;
}
